export default "__VITE_ASSET__Bvou76Aa__"